"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableTopBar = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _TableBarModule = _interopRequireDefault(require("./TableBar.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TableTopBar = _ref => {
  let {
    children,
    className,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    className: (0, _classify.classify)(_TableBarModule.default.tableBar, _TableBarModule.default.topBar, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'top-bar'
    }),
    children: children
  });
};
exports.TableTopBar = TableTopBar;